import { ConstructorArgs as EventConstructorArgs } from "./Event";
import { Events } from "./Events";
import { Event } from "./types";

// TODO Allow an Event class or subclass, or an object of compatible props, or w/e, etc
export type EventArgs = Omit<EventConstructorArgs, `eventId` | `occurredAt`>;

export function event(event: Event) {
  Events.getInstance().dispatch(event);
}